import { useConfiguration } from '../contexts';

export const useLocale = () => {
  const { currentLanguage } = useConfiguration();
  const [locale] = currentLanguage.split('-');

  return locale;
};
